export default __webpack_public_path__ + "static/media/second-right-img.1098eb80.png";